import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PageShell({ children, navVariant = "light", hideFooter = false }) {
    return (
        <div className="min-h-screen flex flex-col bg-[var(--ebg-ivory)]">
            <Nav variant={navVariant} />
            <main className="flex-1">
                {children}
            </main>
            {!hideFooter && <Footer />}
        </div>
    );
}
